import Vue from "vue";
import Router from "vue-router";
import module from "./module";
import Index from "@views/home/Index";
import Index_home from "@views/home/index_home";
import Search from "@views/shop/GoodSearch";
import Category from "@views/shop/GoodsClass";
import ShoppingCart from "@views/shop/ShoppingCart";
import GoodsList from "@views/shop/GoodsList";
import NotDefined from "@views/NotDefined";
import $store from "../store";
import toLogin from "@libs/login";
import Loading from "@views/Loading";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/copy",
      name: "copy",
      meta: {
        title: "新首页",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/home/Copy.vue"),
    },
    {
      path: "/categories",
      name: "categories",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/categories.vue"),
    },

    {
      path: "/index_home",
      name: "index_home",
      meta: {
        title: "首页",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/home/index_home.vue"),
    },
    {
      path: "/InformationVerification",
      name: "InformationVerification",
      meta: {
        title: "信息验证",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/home/InformationVerification.vue"),
    },
    {
      path: "/activity/:id",
      name: "Activity",
      meta: {
        title: "活动周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity.vue"),
    },
    
    {
      path: "/activity1",
      name: "Activity1",
      meta: {
        title: "活动周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity1.vue"),
    },
    {
      path: "/activity2",
      name: "Activity2",
      meta: {
        title: "海礼网活动页面",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity2.vue"),
    },
    {
      path: "/activity3",
      name: "Activity3",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity3.vue"),
    },
    {
      path: "/activity6",
      name: "Activity6",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity6.vue"),
    },
    {
      path: "/activity7",
      name: "Activity7",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity7.vue"),
    },
    {
      path: "/activity8",
      name: "Activity8",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity8.vue"),
    },
    {
      path: "/activity9",
      name: "Activity9",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity9.vue"),
    },
    {
      path: "/activity10",
      name: "Activity10",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity10.vue"),
    },
    {
      path: "/activity11",
      name: "Activity11",
      meta: {
        title: "每日特惠",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity11.vue"),
    },
    {
      path: "/activity12",
      name: "Activity12",
      meta: {
        title: "海礼网活动页面",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity12.vue"),
    },
    {
      path: "/activity13",
      name: "Activity13",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity13.vue"),
    },
    {
      path: "/activity14",
      name: "Activity14",
      meta: {
        title: "海礼网品牌周",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/Activity14.vue"),
    },
    {
      path: "/ElectricalActivities",
      name: "ElectricalActivities",
      meta: {
        title: "海礼网品质家电专场",
        keepAlive: false,
        auth: false,
      },
      component: () => import("@views/shop/ElectricalActivities.vue"),
    },

    {
      path: "/customer/chat/:id/:productId?",
      name: "CustomerService",
      meta: {
        title: "客服聊天",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/user/CustomerService.vue"),
    },
    {
      path: "/user/invoice/:id",
      name: "invoice",
      meta: {
        title: "发票",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/user/invoice/Invoice.vue"),
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Category,
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true,
      },
      component: () => import("@views/shop/GoodsCollection.vue"),
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: Search,
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsDetail.vue"),
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff",
      },
      component: () => import("@views/shop/news/NewsList.vue"),
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true,
      },
      component: () => import("@views/shop/EvaluateList.vue"),
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: true,
      },
      component: () => import("@views/shop/GoodsEvaluate.vue"),
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false,
      },
      component: () => import("@views/shop/GoodsPromotion.vue"),
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false,
      },
      component: () => import("@views/shop/HotNewGoods.vue"),
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false,
      },
      component: () => import("@views/shop/GoodsCon.vue"),
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false,
      },
      component: () => import("@views/shop/StoreList.vue"),
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true,
      },
      component: ShoppingCart,
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true,
      },
      component: GoodsList,
    },
    
    {
      path: "/goods_collection_list/:id",
      name: "GoodsCollectionList",
      meta: {
        title: "商品合集",
        keepAlive: true,
      },
      component: () => import("@views/shop/GoodsClassCollection.vue"),
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true,
      },
      component: () => import(/* webpackChunkName: "login" */ "@views/user/Register.vue"),
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true,
      },
      component: () => import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue"),
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true,
      },
      component: () => import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue"),
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true,
      },
      component: () => import(/* webpackChunkName: "login" */ "@views/user/Login.vue"),
    },
    {
      path: "/bocom/login", //交行授权登录页面
      name: "bocomToken",
      meta: {
        title: "交行授权登录",
        keepAlive: false,
      },
      component: () => import("@views/user/BocomLogin.vue"),
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true,
      },
      component: Loading,
    },
    {
      path: "/:id?",
      name: "Index",
      meta: {
        title: "海尔精选商城",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff",
      },
      component: Index_home,
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB",
      },
      component: NotDefined,
    },
  ],
  scrollBehavior(to, from) {
    from.meta.scrollTop = window.scrollY;
    return { x: 0, y: to.meta.scrollTop || 0 };
  },
});

// const { back, replace } = router;
// // ----------------------------------------------------------------------------------------------
// // - 添加历史记录栈 ：创建 historyStack 数组来记录页面访问历史
// // - 修改 router.back() 方法 ：检查history栈深度，只有栈中页面数大于1时才执行返回
// // - 在路由守卫中记录历史 ：每次导航时记录当前页面路径
// // 记录页面访问历史，用于判断是否可以返回
// let historyStack = [];

// router.back = function() {
//   this.isBack = true;
//   // 检查history栈深度，如果只有1个页面则不执行返回（避免退出App）
//   if (historyStack.length <= 1) {
//     console.log('当前已是首页，禁止返回');
//     return;
//   }
//   historyStack.pop();
//   back.call(router);
// };

// // 在路由守卫中记录访问历史
// router.beforeEach((to, from, next) => {
//   // 只有从其他页面导航过来时才记录
//   if (from.name) {
//     // 避免重复记录相同路径
//     const lastPath = historyStack[historyStack.length - 1];
//     if (lastPath !== to.fullPath) {
//       historyStack.push(to.fullPath);
//     }
//   } else {
//     // 首次进入页面，初始化history栈
//     historyStack = [to.fullPath];
//   }
  
//   const { title, backgroundColor, footer, home, auth } = to.meta;
//   console.log(to.name, from.name);
//   if (auth === true && !$store.state.app.token) {
//     if (from.name === "Login") return;
//     $store.commit("LOGOUT");
//     return toLogin(true, to.fullPath);
//   }
//   document.title = title || process.env.VUE_APP_NAME || "海礼网商城";
//   //判断是否显示底部导航
//   footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

//   //控制悬浮按钮是否显示
//   home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

//   $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

//   if (auth) {
//     $store.dispatch("USERINFO").then(() => {
//       next();
//     });
//   } else next();
// });
// router.replace = function(...args) {
//   this.isReplace = true;
//   replace.call(router, ...args);
// };
// -------------------------------------------------------------------------------------------------------
router.beforeEach((to, from, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta;
  console.log(to.name, from.name);
  
  // 记录上一页路径到sessionStorage（排除登录页面）
  if (from.name && from.path !== '/login' && from.path !== '/bocom/login') {
    // 存储完整URL（包含域名）
    const fullBackUrl =  from.fullPath;
    sessionStorage.setItem('backUrl', fullBackUrl);
    console.log('记录上一页路径:', fullBackUrl);
  }
  
  // 如果需要认证
  if (auth === true) {
    // 检查 Vuex 和 localStorage 中的 token
    const vuexToken = $store.state.app.token;
    const localStorageToken = localStorage.getItem("token");
    
    // 如果 Vuex 中没有 token，但 localStorage 中有，先同步到 Vuex
    if (!vuexToken && localStorageToken) {
      console.log('同步 localStorage token 到 Vuex');
      $store.commit("LOGIN", { token: localStorageToken, expires_time: Date.now() + 86400000 });
    }
    
    // 再次检查 token
    if (!$store.state.app.token) {
      if (from.name === "Login") return;
      return toLogin(true, to.fullPath);
    }
  }
  
  document.title = title || process.env.VUE_APP_NAME || "海礼网商城";
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER");

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next();
    });
  } else next();
});

router.afterEach((to, from) => {
  // 每次页面跳转后，将 meta[name="gobackPage"] 的 content 更新为上一个页面的完整链接
  const gobackPageMeta = document.querySelector('meta[name="gobackPage"]');
  if (gobackPageMeta && from.name) {
    gobackPageMeta.setAttribute('content', location.origin + from.fullPath);
  }

  setTimeout(() => {
    let { origin, pathname } = location;
    SRSAPP && SRSAPP.onEvent("2668029000", origin + pathname);
  }, 30);
});

// 监听浏览器的 popstate 事件（App返回键可能触发）
// if (typeof window !== 'undefined') {
//   window.addEventListener('popstate', (event) => {
//     console.log('popstate 事件被触发，当前历史栈长度:', historyStack);
//     if (this.$route.query.from === '1') {
//       console.log('关闭当前窗口');
//         window.close();
//         return;
//     }
//     // 如果历史栈长度小于等于1，阻止返回
//     if (historyStack.length <= 1) {
//       console.log('阻止App返回退出');
//       // 阻止默认行为
//       event.preventDefault();
//       // 重新push当前路径，保持页面不变
//       if (router.currentRoute) {
//         history.pushState(null, '', router.currentRoute.fullPath);
//       }
//       return;
//     }
    
//     // 正常返回时，更新历史栈
//     historyStack.pop();
//   });
// }

export default router;
